export function HorizontalLine() {

    return (
        <div className="bg-blue-300 w-full h-0.5 rounded"/>
    );
}